// 组件 borderTab.vue 中的tabs切换标题 定义内容
const TAB_MAP_VALUE = {
  1: "采购成本公开",
  2: "餐价公开",
  3: "收入支出公开",
  7: "评价公开",
  9: "检测公开",
  22: "餐价公开",
  10: "包餐价格公开", // (当天)餐价公示(统缴餐&自选餐)
  11: "选餐价格公开",
  12: "包餐价格公开",
  13: "营养菜谱公开",
};

// 需要处理隐藏对应Tab头部背景和顶部信息(校名时间) 的 类别
const copyObj = JSON.parse(JSON.stringify(TAB_MAP_VALUE)); // 默认所有
// 排除个别
const SPECIAL_ONE = '10';
delete copyObj[SPECIAL_ONE]; 
const HIDE_BG_TAB = Object.keys(copyObj);

export { 
  TAB_MAP_VALUE, 
  SPECIAL_ONE, 
  HIDE_BG_TAB 
};
